import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ISharingPeriod } from '../../type/twoFactor';
import { FamilyApprovedPerson } from './FamilyApproval';

export interface  ApprovalInterface {   approvalDuration?: ISharingPeriod;   selectedForApprovalPersons?: FamilyApprovedPerson[] }

interface KeycloakRef {
  kundenNr: string;
  keycloakId: string;
}

interface QrApprovalContextType {
  qrApprovalValue?: ApprovalInterface;
  setQrApprovalValue: React.Dispatch<React.SetStateAction<ApprovalInterface | undefined>>;

  qrKeycloakRef?: KeycloakRef;
  setQrKeycloakRef: React.Dispatch<React.SetStateAction<KeycloakRef | undefined>>;
}

const QrApprovalContext = createContext<QrApprovalContextType | undefined>(undefined);

export const QrApprovalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [qrApprovalValue, setQrApprovalValue] = useState<ApprovalInterface | undefined>(undefined);
  const [qrKeycloakRef, setQrKeycloakRef] = useState<KeycloakRef | undefined>(undefined);

  return (
    <QrApprovalContext.Provider
      value={{
        qrApprovalValue,
        setQrApprovalValue,
        qrKeycloakRef,
        setQrKeycloakRef,
      }}
    >
      {children}
    </QrApprovalContext.Provider>
  );
};

export const useQrApprovalContext = (): QrApprovalContextType => {
  const context = useContext(QrApprovalContext);
  if (!context) {
    throw new Error('useQrApprovalContext must be used within a QrApprovalProvider');
  }
  return context;
};
